const enPages = {
  // forgot password
  forgotPasswordPage_TitleForgotPassword: 'Forgot password',
  forgotPasswordPage_EmailAddress: 'Please input your email and username',
  forgotPasswordPage_Submit: 'Submit',
  forgotPasswordPage_BackToLoginPage: 'Back to login page',
  forgotPasswordPage_ForgotPasswordSuccess: `We has sent an email to <b>{{email}}</b> requesting a password reset!
                                            <br/>Please click on the link within 30 minutes.
                                            <br/>Or you will need to request a new link.
                                            <br/>If you do not see the email, please check your spam folder. `,
  forgotPasswordPage_ForgotPassword_Hint: `A URL to reset your password will be sent to you.
                                            <br />Please enter your registered e-mail address and click the "Submit" button. `,

  //reset password
  resetPasswordPage_TitleResetPassword: 'Reset password',
  resetPasswordPage_SubTitleResetPassword: 'Enter the new password',
  resetPasswordPage_TitleHint: 'Please set a new password.',
  resetPasswordPage_ForgotPasswordSessionExpired: 'Forgot Password session has expired',
  resetPasswordPage_ResetPasswordSuccess: 'Reset password success',
  resetPasswordPage_passwordValidation: 'Password invalid',
  resetPasswordPage_NewPassword: 'New password',
  resetPasswordPage_ConfirmPassword: 'Confirm password',
  resetPasswordPage_PasswordNotMatch: 'The password entered does not match',
  // login pages
  loginPage_WelcomeBack: 'Welcome back!',
  loginPage_HaveAccount: "Don't have an account yet?",
  loginPage_SignUpFree: 'Sign up for an account',
  loginPage_ForgotPassword: 'Forgot your password?',
  //password expired page
  passwordExpiredPage_Title: 'Your password has expired',
  passwordExpiredPage_PleaseChangePass: 'Please change your password',
  passwordExpiredPage_ChangePassword: 'Change password',
  // agent register page
  agentRegister_HaveAccount: 'Already have an account?',
  agentRegister_Welcome: 'Welcome',
  agentRegister_CompanyDetail: 'Company detail',
  agentRegister_CompanyName: 'Company name',
  agentRegister_CompanyNumber: 'Company number',
  agentRegister_CompanyType: 'Company type',
  agentRegister_IATAId: 'IATA ID',
  agentRegister_UserName: 'Username (For login)',
  agentRegister_Accountant: 'Accountant',
  agentRegister_DoYouHaveLicense: 'LICENSE INFO',
  agentRegister_TravelAgentLicenseFile: 'Travel agent license (Please upload images, pdf, doc or docx files)',
  agentRegister_TradingName: 'Trading name',
  agentRegister_TravelAgentId: 'Travel agent ID',
  agentRegister_EmergencyContact: 'Emergency contact',
  agentRegister_PersonInCharge: 'Person in charge',
  agentRegister_UploadedLicenseFiles: 'Uploaded license files',
  agentRegister_CreditCard: 'Credit Card',
  agentRegister_AddCreditCard: 'Add new credit card',
  // home page
  homePage_SearchTitle: 'Search the hotel',
  homePage_SubSearchTitle: 'From traditional Japanese style Inns to luxury city Hotels',
  homePage_SearchCheckInCheckOut: 'Check-in - Check-out',
  homePage_Search: 'Search',
  homePage_BoardType: 'Board type',
  // hotel list
  hotelListPage_HotelsMap: 'Hotels map',
  hotelListPage_ViewOnMap: 'View on map',
  hotelListPage_BoardType: 'Board type',
  // on hold booking
  agentOnHoldBookingListPage_PageTitle: 'On hold bookings',
  agentOnHoldBookingListPage_PageSubTitle: 'Manage agent on hold bookings',
};

export default enPages;
